import {
  mdiCarArrowRight,
  mdiCogOutline,
  mdiCogs,
  mdiLayersOutline,
} from '@mdi/js'

// import localStorageSlim from 'localstorage-slim'

// const userProfile = localStorageSlim.get('userProfile', { decrypt: true })
// const profileName = userProfile?.profile?.profile

const transport = [
  {
    subheader: 'Transporte',
  },
]

transport.push({
  title: 'SOLICITAÇÕES',
  icon: mdiCarArrowRight,
  to: 'transport-solicitations',
  hidden: false,
  ActiveTabColor: '#ff5b03',
  ActiveTabColor2: '#fc7600',
})
transport.push({
  title: 'CADASTROS',
  icon: mdiLayersOutline,
  children: [
    {
      title: 'Motoristas',
      to: 'register-driver',
      hidden: false,
      ActiveTabColor: '#ff5b03',
      ActiveTabColor2: '#fc7600',
    },
    {
      title: 'Veículos',
      to: 'register-vehicle',
      hidden: false,
      ActiveTabColor: '#ff5b03',
      ActiveTabColor2: '#fc7600',
    },
    {
      title: 'Baterias',
      to: 'register-battery',
      hidden: false,
      ActiveTabColor: '#ff5b03',
      ActiveTabColor2: '#fc7600',
    },

    {
      title: 'Manutenção',
      to: 'register-maintenance',
      hidden: false,
      ActiveTabColor: '#ff5b03',
      ActiveTabColor2: '#fc7600',
    },

    // {
    //   title: 'Quilometragem',
    //   to: 'register-mileage',
    //   hidden: false,
    //   ActiveTabColor: '#ff5b03',
    //   ActiveTabColor2: '#fc7600',
    // },
    {
      title: 'Abastecimento',
      to: 'register-fuelSupply',
      hidden: false,
      ActiveTabColor: '#ff5b03',
      ActiveTabColor2: '#fc7600',
    },
    {
      title: 'Checklist Diário',
      to: 'transport-daily-checklist',
      hidden: false,
      ActiveTabColor: '#ff5b03',
      ActiveTabColor2: '#fc7600',
    },
  ],
})
transport.push({
  title: 'FERRAMENTAS',
  icon: mdiCogs,
  children: [
    {
      title: 'Fornecedor',
      to: 'tools-suppliers',
      hidden: false,
      ActiveTabColor: '#ff5b03',
      ActiveTabColor2: '#fc7600',
    },
    {
      title: 'Bateria',
      to: 'tools-battery',
      hidden: false,
      ActiveTabColor: '#ff5b03',
      ActiveTabColor2: '#fc7600',
    },

    // {
    //   title: 'Manutenção',
    //   to: 'tools-maintenance',
    //   hidden: false,
    //   ActiveTabColor: '#ff5b03',
    //   ActiveTabColor2: '#fc7600',
    // },
    {
      title: 'Veículo',
      to: 'tools-vehicle',
      hidden: false,
      ActiveTabColor: '#ff5b03',
      ActiveTabColor2: '#fc7600',
    },
  ],
})

transport.push({
  title: 'PARÂMETROS',
  icon: mdiCogOutline,
  children: [
    {
      title: 'Permissões',
      to: 'params-permissions',
      hidden: false,
      ActiveTabColor: '#ff5b03',
      ActiveTabColor2: '#fc7600',
    },
  ],
})

export default transport
